import { makeStyles } from '@mui/styles'

const useStyle = makeStyles(() => ({
  rowChecked: {
    borderRadius: 8,
    cursor: 'pointer',
    backgroundColor: '#ececec',
    '& #kebab': {
      color: '#263057'
    }
  },
  row: {
    borderRadius: 8,
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: '#ececec',
      '& #kebab': {
        color: '#263057'
      }
    },
  },
  cuit: {
    height: 44,
    fontFamily: 'Roboto',
    fontSize: 14,
    fontWeight: 'bold',
    color: '#6e7a76',
    textAlign: 'center',
    textOverflow: 'ellipsis',
    width: '15%',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    '@media all and (max-width: 600px)': {
      fontSize: 12,
      padding: '0px 10px'
    },
  },
  date: {
    height: 44,
    fontFamily: 'Roboto',
    fontSize: 14,
    fontWeight: 'bold',
    color: '#6e7a76',
    textAlign: 'center',
    textOverflow: 'ellipsis',
    width: '20%',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    '@media all and (max-width: 1090px)': {
      display: 'none',
    }
  },
  status: {
    height: 44,
    fontFamily: 'Roboto',
    fontSize: 14,
    fontWeight: 'bold',
    color: '#6e7a76',
    textAlign: 'center',
    textOverflow: 'ellipsis',
    width: '40%',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    '@media all and (max-width: 600px)': {
      fontSize: 12,
    },
  },

  itemKebab: {
    height: 44,
    fontFamily: 'Roboto',
    fontWeight: 'bold',
    color: '#2C3532',
    width: '10%',
    cursor: 'pointer',
    textAlign: 'center',
    borderTopRightRadius: 8,
    borderBottomRightRadius: 8,
    '&:hover': {
      backgroundColor: '#ececec'
    }
  },
  kebab: {
    color: '#B3B3B3'
  }
}))

export default useStyle
